import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="lg:w-2/5 flex-shrink-0">
            <span className="inline-block border border-accent-300 text-accent-700 text-xs font-medium px-4 py-1 rounded-full mb-6">
              Guia CSSBuy
            </span>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20modern%20workspace%20interior%20with%20organized%20shelves%20displaying%20curated%20fashion%20products%20and%20accessories%20warm%20natural%20light%20streaming%20through%20large%20windows%20clean%20industrial%20refined%20aesthetic%20soft%20cream%20tones%20contemporary%20storage%20design%20professional%20editorial%20photography%20with%20shallow%20depth%20of%20field%20sophisticated%20atmosphere&width=800&height=1000&seq=about-cssbuy-v3-2026&orientation=portrait"
                alt="CSSBuy Spreadsheet Warehouse"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.08] tracking-tight">
              Descubra o<br />
              <span className="text-accent-600">CSSBuy</span> Spreadsheet
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              Muitos utilizadores compram produtos errados, encontram vendedores falsos ou pagam preços elevados desnecessariamente. O nosso CSSBuy Spreadsheet foi criado para resolver exatamente este problema.
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              Reunimos mais de 50.000 produtos verificados numa única plataforma, organizada por categorias e atualizada diariamente. Cada link é testado e aprovado pela nossa comunidade antes de ser incluído na planilha.
            </p>

            <div className="mt-6 space-y-3">
              {[
                'Produtos populares e tendências atuais',
                'Fornecedores confiáveis com boa reputação',
                'Melhor relação qualidade-preço do mercado',
                'Atualizações constantes com novos produtos',
                'Segurança total nas suas compras online',
              ].map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 rounded-full bg-accent-100">
                    <i className="ri-check-line text-xs text-accent-600"></i>
                  </span>
                  <span className="text-sm text-foreground-700">{item}</span>
                </div>
              ))}
            </div>

            <Link
              to="/artigo/cssbuy-spreadsheet-guia-completo-2026"
              className="inline-flex items-center gap-2 mt-8 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Leia o guia completo
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}